// pages/PartnerOnboarding.js
import React, { useState } from 'react';
import StepIndicator from '../components/partnerOnboarding/stepIndicator';
import PersonalInfo from '../components/partnerOnboarding/personalInfo';
import PromotionLinks from '../components/partnerOnboarding/promotionLinks';
import DashboardTour from '../components/partnerOnboarding/dashboardTour';
import Navigation from '../components/partnerOnboarding/navigation';

function PartnerOnboarding() {
  const [currentStep, setCurrentStep] = useState(1);
  const totalSteps = 3;

  const nextStep = () => setCurrentStep(prev => Math.min(prev + 1, totalSteps));
  const prevStep = () => setCurrentStep(prev => Math.max(prev - 1, 1));

  const renderStep = () => {
    switch(currentStep) {
      case 1: return <PersonalInfo />;
      case 2: return <PromotionLinks />;
      case 3: return <DashboardTour />;
      default: return null;
    }
  };

  return (
    <div className="kmint container onboarding-container">
    <div className='row'>
        <div className='col-2'></div>
        <div className='col-8'>
          <h1 className="text-center mb-4">Become a MintDeals Partner!</h1>
          <p className="text-center mb-4">Join our affiliate program and start earning commissions by promoting local businesses.</p>
          
          <StepIndicator currentStep={currentStep} totalSteps={totalSteps} />
          
          <div className="card">
            <div className="card-body">
              {renderStep()}
              <Navigation 
                currentStep={currentStep} 
                totalSteps={totalSteps} 
                nextStep={nextStep} 
                prevStep={prevStep} 
              />
            </div>
          </div>
        </div>
          <div className='col-2'></div>
        </div>

    </div>

  );
}

export default PartnerOnboarding;
